<div *ngIf="isLoading | async" class="overlay">
  loader-component works!
</div>